import { createFileRoute } from '@tanstack/react-router';

import { meQueryOptions } from '@/features/me/api';
import { MePage } from '@/features/me/components/me-page';

export const Route = createFileRoute('/_app/me')({
  staticData: { title: '내 정보' },
  loader: ({ context: { queryClient } }) =>
    queryClient.query({ ...meQueryOptions(), staleTime: 'static' }),
  head: () => ({ meta: [{ title: '내 정보 · 팬즈드롭 파트너' }] }),
  component: MePage,
});
